(function($) {
  'use strict';

    function closeMessage(e) {
      e.preventDefault();
      $(this).parent().remove();
    }

    $(document).on('click', 'a.messageclose', closeMessage);
})(jQuery);
